import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
/*
 * `home.css` is shared, not Home-only: the customize flow (StepComp3-7), booking summary,
 * booking detail, review and gift-card detail screens all depend on its classes. It used to
 * be imported only by Home.js, so it shipped inside Home's lazy chunk — reaching any of
 * those routes directly (refresh / deep link) rendered them unstyled, most visibly the
 * body diagrams blowing up to full size because `.body_image` was missing. Loading it with
 * the entry CSS makes the styling independent of which route mounted first. Imported last
 * so it keeps winning over bootstrap, exactly as it did when injected at runtime.
 */
import './Screen/Autherised/home/home.css';

import './i18n';
// Registers dayjs plugins (duration, localeData, ...) for every `import dayjs` in the app.
import './utils/dayjsSetup';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initMonitoring } from './utils/monitoring';
import reportWebVitals from './reportWebVitals';

// Start error monitoring before render so early failures are captured.
// No-ops unless REACT_APP_SENTRY_DSN is configured.
initMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

/*
 * Service worker update handling.
 *
 * This used to fire a blocking `alert()` and immediately reload, interrupting whatever the
 * user was doing (mid-booking, mid-payment) and discarding unsaved input. Now the waiting
 * worker is asked to activate and the page refreshes once it takes control, so the update
 * applies on the next natural navigation instead of yanking the page away.
 */
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        const waiting = registration?.waiting;
        if (!waiting) return;

        waiting.postMessage({ type: 'SKIP_WAITING' });
        let refreshing = false;
        navigator.serviceWorker?.addEventListener('controllerchange', () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        });
    },
});

// Report Core Web Vitals. `web-vitals` was already a dependency but was never wired up.
reportWebVitals();
